import React from 'react';
import styles from './styles';
import Search from './Common/Search';
import { SEARCH_TYPE, ACTIVE_DETAILS } from './constants';
import { getDataWithQueryString } from '../../../../api/componentAPIs';
import { withStyles, Grid } from '@material-ui/core';
import { compose } from 'recompose';
import { withUserProfile } from '../../../../userProfile/userProfileContext';
import { getUTCDate } from '@dataGrid/gridUtilities';
import { format } from 'date-fns';
import RouteDetails from './RouteDetails';
import StopDetails from './StopDetails';
import NotFound from './Common/NotFound';
import StopList from './Common/StopList';
import { AppLoading } from '../../../../loaders/loaders';
import { getStopListByRouteId, getRoute } from './Utils';
import appConstants from '../../../../appConstants';
import { getDefaultDateRange } from '../../Dispatch/DispatchChat/MessageHistory/utils';
import { getAllDriversForMessageHistory } from '../DriverPerformance/util';
import MessageHistory from '../../Dispatch/DispatchChat/MessageHistory';
import { RMAXLogger } from '../../../../services/LoggerService/RMAXLogger';

class RecordsLookups extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchBy: SEARCH_TYPE.DriverNumber,
      searchInputValue: '',
      driverData: null,
      showLoader: false,
      selectedRouteId: null,
      selectedStopIndex: 1,
      activeDetail: ACTIVE_DETAILS.ROUTE_COMPLIANCE,
      showError: false,
      openMessageHistory: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.userData.userProfile.terminal.id !== prevProps.userData.userProfile.terminal.id
    ) {
      this.setState({ driverData: null });
    }
  }

  handleSearch = (searchBy, searchInputValue, dispatchDate) => {
    searchInputValue && this.searchRecord(searchBy, searchInputValue, dispatchDate);
  };

  handleRouteChange = (value) => {
    if (this.state.selectedRouteId !== value?.value) {
      this.setState({ selectedRouteId: value?.value || null, selectedStopIndex: 1 });
    }
  };

  searchRecord = (searchBy, searchInputValue, dispatchDate) => {
    this.setState({ showLoader: true });
    let query = `terminalCode=${this.props.userData.userProfile.terminal.code}&${searchBy}=${searchInputValue}`;
    if (searchBy === SEARCH_TYPE.DriverNumber) {
      query = `${query}&dispatchDate=${format(
        getUTCDate(dispatchDate),
        appConstants.APP_DATE_FORMAT
      )}`;
    }
    getDataWithQueryString('SearchRecord', query).then((response) => {
      if (response.status === 200 && response.data.length) {
        const driverData = response.data[0];
        const hasRoutes = driverData?.routes?.length > 0;
        let selectedRouteId = hasRoutes ? driverData.routes[0].routeId : null;
        let selectedStopIndex = 1;
        let activeDetail = ACTIVE_DETAILS.ROUTE_COMPLIANCE;
        if (driverData.activeStopDetails) {
          selectedRouteId = driverData.activeStopDetails.routeId;
          selectedStopIndex = getStopListByRouteId(driverData, selectedRouteId).find(
            (stop) => stop.stopId === driverData.activeStopDetails.stopId
          )?.stopSequence || 1;
          activeDetail = ACTIVE_DETAILS.STOP;
        }
        const route = getRoute(driverData, selectedRouteId);
        const showError = !hasRoutes || !route;
        this.setState({
          searchBy,
          searchInputValue,
          driverData,
          showError,
          showLoader: false,
          selectedRouteId,
          selectedStopIndex,
          activeDetail,
          dispatchDate
        });
        if (!route) {
          RMAXLogger.warn(`Record lookup route data not found`, {
            selectedStopIndex,
            searchInputValue,
            routeIds: driverData.routes.map((route) => route.routeId)
          });
        }
      } else {
        this.setState({
          searchBy,
          searchInputValue,
          driverData: null,
          showError: true,
          showLoader: false,
          dispatchDate
        });
      }
    });
  };

  getDriverOptions = () => {
    const {driverName, driverId, driverNumber} = this.state.driverData;
    return getAllDriversForMessageHistory([{
      driverName,
      driverNumber,
      driverId,
    }])
  }

  onMessageHistoryClick = () => {
    this.setState({
      openMessageHistory: true
    });
  }

  closeMessageHistoryClick = () => {
    this.setState({
      openMessageHistory: false
    });
  }

  renderComponent = () => {
    const {
      driverData,
      showError,
      activeDetail,
      selectedRouteId,
      selectedStopIndex,
      searchInputValue,
      searchBy,
      dispatchDate
    } = this.state;
    const route = getRoute(driverData, selectedRouteId);
    if (showError) {
      return (
        <NotFound
          searchBy={searchBy}
          searchInputValue={searchInputValue}
          driverData={format(getUTCDate(dispatchDate), appConstants.APP_DATE_FORMAT)}
        />
      );
    }
    if (driverData?.routes?.length) {
      if (activeDetail === ACTIVE_DETAILS.ROUTE_COMPLIANCE) {
        return (
          <RouteDetails
            driverData={driverData}
            route={route}
            glEventHub={this.props.glEventHub}
          />
        );
      } else {
        return (
          <StopDetails
            route={route}
            stops={getStopListByRouteId(driverData, selectedRouteId)}
            selectedStopIndex={selectedStopIndex}
            glEventHub={this.props.glEventHub}
            searchInputValue={searchInputValue}
          />
        );
      }
    }
  };

  onActivePageChange = () => {
    if (this.state.activeDetail === ACTIVE_DETAILS.ROUTE_COMPLIANCE) {
      this.setState({ activeDetail: ACTIVE_DETAILS.STOP, selectedStopIndex: 1 });
    } else {
      this.setState({
        activeDetail: ACTIVE_DETAILS.ROUTE_COMPLIANCE,
        selectedStopIndex: 0
      });
    }
  };

  onStopSelectionChange = (selectedStopIndex) => {
    this.setState({ selectedStopIndex });
  };

  render() {
    const { classes, userData } = this.props;
    const {
      driverData,
      showLoader,
      activeDetail,
      selectedRouteId,
      selectedStopIndex,
      openMessageHistory
    } = this.state;
    const route = getRoute(driverData, selectedRouteId);
    return (
      <div className={classes.container}>
        <header className={classes.header}>
          <span className={classes.headerText}>Records Lookup</span>
        </header>
        <Grid container spacing={24} className={`${classes.viewContainer} customScroll`}>
          <Grid item xs={4} className={classes.fullHeight}>
            <Search
              showLoader={showLoader}
              handleSearch={this.handleSearch}
              key={userData.userProfile.terminal.code}
            />
            {!showLoader && driverData?.routes?.length && route ? (
              <>
                <StopList
                  driverData={driverData}
                  stops={getStopListByRouteId(driverData, selectedRouteId)}
                  handleRouteChange={this.handleRouteChange}
                  activeDetail={activeDetail}
                  onActivePageChange={this.onActivePageChange}
                  selectedStopIndex={selectedStopIndex}
                  terminalCode={userData.userProfile.terminal.code}
                  onStopSelectionChange={this.onStopSelectionChange}
                  route={route}
                  onMessageHistoryClick={this.onMessageHistoryClick}
                />
                {openMessageHistory && (
                  <MessageHistory
                    onClose={this.closeMessageHistoryClick}
                    defaultDriver={driverData.driverId}
                    defaultDateRange={getDefaultDateRange()}
                    defaultTerminalCode={driverData.routes[0]?.terminalCode}
                    defaultTerminalOffset={userData.userProfile.terminal.offset}
                    driverOptions={this.getDriverOptions()}
                    isDriverChangeDisabled
                  />
                )}
              </>
            ) : null}
          </Grid>
          <Grid item xs={8} className={classes.fullHeight}>
            {showLoader ? (
              <div id="appContainer" className={classes.appLoad}>
                <AppLoading />
              </div>
            ) : (
              this.renderComponent()
            )}
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default compose(withStyles(styles), withUserProfile)(RecordsLookups);
